import { render, staticRenderFns } from "./项目政策法规查询.vue?vue&type=template&id=af593372&scoped=true"
import script from "./项目政策法规查询.vue?vue&type=script&lang=js"
export * from "./项目政策法规查询.vue?vue&type=script&lang=js"
import style0 from "./项目政策法规查询.vue?vue&type=style&index=0&id=af593372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af593372",
  null
  
)

export default component.exports